import axios from "axios";

export interface StudentRow {
  studentId: string;
  admissionNumber: string;
  scholarNumber: string | null;
  studentName: string;
  class: string;
  section: string;
}

export interface SubjectItem {
  id: string;
  name: string;
  code?: string;
}

export const studentSubjectApi = {
  getStudents: async (filters: { academicSessionId: string; classId?: string; sectionId?: string }) => {
    const res = await axios.get<StudentRow[]>("/scholar-register/student-subject/students", { params: filters });
    return res.data;
  },
  getSubjectsByClass: async (classId: string) => {
    const res = await axios.get<SubjectItem[]>("/system-settings/subject", { params: { classId } });
    return res.data;
  },
  getStudentSubjects: async (studentId: string, academicSessionId: string) => {
    const res = await axios.get(`/scholar-register/student-subject/${studentId}`, { params: { academicSessionId } });
    return res.data as Array<{ subject: SubjectItem; isOptional: boolean }>;
  },
  assignSubjects: async (payload: {
    studentId: string;
    subjectIds: string[];
    academicSessionId: string;
    classId: string;
    sectionId: string;
    optionalSubjectIds?: string[];
  }) => {
    const res = await axios.post("/scholar-register/student-subject", payload);
    return res.data as { assigned: number };
  },
};
